import { createSelector } from 'reselect';
import defaultServiceLocationSelector from './defaultServiceLocationSelector';
import { formatPhoneNumber } from '../../../lib/numUtils.js';
import selectors from '../../../selectors/selectors.js';
import evalFormFields from '../../../lib/evalFormFields.js';
import toTitleCase from '../../../lib/toTitleCase.js';
import getMatchedWebFormFields from 'lib/getMatchedWebFormFields.js';

const defaultServiceLocation = (state) => defaultServiceLocationSelector(state);
const pipelines = (state) => state.currentServiceProvider.pipelines;
const userId = (state) => (state.user || {}).id;

const selectorSet = [selectors.activeNonLeadMessage, defaultServiceLocation, pipelines, userId, selectors.serviceProviderServices, selectors.serviceProviderLocations, selectors.serviceProviderServicePersons];
const createLeadFormDefaultValuesSelector = createSelector(...selectorSet, (activeNonLeadMessage, defaultServiceLocation, pipelines, userId, services, locations, servicePersons) => {
  const message = activeNonLeadMessage || {};
  const threadMeta = message.thread_meta || {};
  const firstPipelineId = ((pipelines || [])[0] || {}).id;
  const firstStageId = ((((pipelines || [])[0] || {}).stages || [])[0] || {}).id;
  const [callerFirst, callerLast] = String(message.caller_name || '').split(/ (.+)/);
  const formFields = evalFormFields(message.form_fields);

  const matchedFields = getMatchedWebFormFields({ formFields, services, locations, servicePersons });

  return {
    is_business: false,
    business_name: message.business_name || undefined,
    service_location_id: (matchedFields.location || defaultServiceLocation || {}).id,
    service_person_id: (matchedFields.servicePerson || {}).id || null,
    pipeline_stage_name: null,
    pipeline_user_id: userId,
    pipeline_id: firstPipelineId,
    pipeline_stage_id: firstStageId,
    first_name: toTitleCase(String(threadMeta.first_name || message.first_name || callerFirst || message.from_name || (formFields || {}).Name || '').trim()),
    last_name: toTitleCase(String(threadMeta.last_name || message.last_name || callerLast || '').trim()),
    email_address: threadMeta.email || message.email_address,
    phone_number: formatPhoneNumber(threadMeta.phone || message.caller_number || message.from_phone_number || message.phone_number),
    utm_medium: message.utm_medium,
    utm_source: message.utm_source,
    utm_campaign: message.utm_campaign,
    title: null,
    date_of_birth: formFields.dateOfBirth,
    website: (formFields || {}).webUrl || (formFields || {}).website,
    gender: formFields.gender || null,
    service_interests: matchedFields.serviceInterests,
    statusId: null,
    subStatusId: null,
    note: '',
    statusDate: new Date(),
  };
});

export default createLeadFormDefaultValuesSelector;
